import Mask from '../../../components/Mask';
import { inject, observer } from 'mobx-react';
import s from './BackModal.module.scss';
import { Popup } from 'antd-mobile';
import MyIcon from '@/components/MyIcon';
import whenImg from '@/assets/images/simulation/when.png';
import whatImg from '@/assets/images/simulation/what.png';
import whereImg from '@/assets/images/simulation/where.png';
import whoImg from '@/assets/images/simulation/who.png';
import whyImg from '@/assets/images/simulation/why.png';
import { factorMapStr } from '@/utils/contants/caseSimulation';

const iconMap = {
    1: whenImg,
    2: whereImg,
    3: whoImg,
    4: whatImg,
    5: whyImg
};
const BackModal = (props) => {
    const { onClose, show } = props;
    let { simulation } = props.store;
    let { background, caseInfo } = simulation;

    return (
        <>
            <Popup
                showCloseButton={false}
                bodyStyle={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    overflow: 'hidden'
                }}
                onMaskClick={onClose}
                visible={show}
            >
                <div className={s.modalWrap}>
                    <div className={s.boxWrap}>
                        <div className={s.title}>
                            {/* 占位用，保持title居中 */}
                            <span className={s.closeIcon} style={{ visibility: 'hidden' }}>
                                <MyIcon type="icon-a-guanbi31" />
                            </span>
                            <span className={s.roleText}> 背景回顾</span>
                            <span onClick={onClose} className={s.closeIcon}>
                                <MyIcon type="icon-a-guanbi31" />
                            </span>
                        </div>

                        <div className={s.sectionWrap}>
                            <div className={s.caseTitle}>{caseInfo?.case_title}</div>
                            {background?.sections?.map((item, index) => (
                                <div key={index} className={s.sectionItem}>
                                    <div className={s.top}>
                                        <div className={s.icon}>
                                            <img src={iconMap[item?.section_id]} alt="" />
                                        </div>
                                        <div className={s.sectionTitle}>{factorMapStr[item?.section_id] || item?.title}</div>
                                    </div>
                                    <div className={s.sectionContent}>{item?.content}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default inject('store')(observer(BackModal));
